module.exports = __webpack_public_path__ + "img/yb7.10bff884.jpg";